import { config } from "@/config";

export const HOTELS_ORG_ID = config.hotelsOrgId;
export const BRISTOL_ORG_ID = config.bristolOrgId;
export const FLEX_ORG_ID = config.flexOrgId;

// Bristol is treated the same as Hotels (agreements, name/phone fields, theming, etc.)
export const isHotelsLikeOrg = (orgId: string | undefined): boolean =>
  orgId === HOTELS_ORG_ID || orgId === BRISTOL_ORG_ID;

// For the few places where Bristol diverges from Hotels (illustrations, hover color)
export const isBristolOrg = (orgId: string | undefined): boolean =>
  !!orgId && orgId === BRISTOL_ORG_ID;
